import { ApplicationNames } from "../../consts";
import { Component, Input, OnInit } from "@angular/core";
import { ExceptionsService } from "../../services/utelize/general/exceptions-service";
import { WidgetLiveTimeLineDTO } from "../../models/system/widget/widget-live-timeline.dto";

@Component({
  selector: 'app-page-comp-timeline',
  templateUrl: './page-comp-timeline.component.html',
  styleUrls: ['./page-comp-timeline.component.scss']
})

export class PageCompTimelineComponent implements OnInit {
  
  @Input() liveTimeLineData: WidgetLiveTimeLineDTO[] | undefined;

  // public gfg        : any[] | undefined;
  public sureSimName: string=ApplicationNames.SureSIM;

  constructor(
    private exceptionsService: ExceptionsService
  ) {
    
  }

  public ngOnInit(): void {
    try {
      // this.gfg=[
      //   {
      //     status: "Time 1",
      //     date: '2025-04-05 09:00 AM',
      //     name: "Chris Norwood"
      //   },
      // ];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
